export const apodisCoinConfig = {
    threshold: 100,
    reward: 1
};